import React from "react";
import WCPhoneInput from "../../../common/forms/wcPhoneInput";
import phoneService from "../../../../services/phoneService";
import { getProfilePhoneError, isProfilePhoneEmpty } from "../registrationWizardValidation";
import RegistrationWizardState from "../registrationWizardState";

class PhotoPhoneStep extends React.Component {
  state = { phoneError: "" };

  componentDidUpdate(prevProps) {
    if (this.props.showValidation && !prevProps.showValidation) {
      const phone = RegistrationWizardState.getStepData().phone.value;
      if (!isProfilePhoneEmpty(phone)) {
        const error = getProfilePhoneError(phone);
        if (error) {
          this.setState({ phoneError: error });
        }
      }
    }

    if (this.props.saveError && this.props.saveError !== prevProps.saveError) {
      this.setState({ phoneError: this.props.saveError });
    }
  }

  onPhoneChange = (phone) => {
    let normalizedPhone = isProfilePhoneEmpty(phone) ? phoneService.emptyPhone() : phone;
    if (!isProfilePhoneEmpty(normalizedPhone)) {
      normalizedPhone = phoneService.normalizeSubAccountPhone(normalizedPhone);
      const enriched = phoneService.withLineNumber(normalizedPhone);
      if (!enriched?.lineNumber) {
        normalizedPhone = phoneService.emptyPhone();
      }
    }
    RegistrationWizardState.updateField("phone", normalizedPhone);
    RegistrationWizardState.updateField("phoneEdited", true);
    this.props.onSaveErrorClear?.();
    const error = getProfilePhoneError(normalizedPhone) || "";
    this.setState({ phoneError: error });
  };

  renderPhoneField = () => {
    const { showValidation, saveError } = this.props;
    const phone = RegistrationWizardState.getStepData().phone.value || phoneService.emptyPhone();
    const { phoneError } = this.state;
    const validationError = getProfilePhoneError(phone) || "";
    const displayError = phoneError || saveError || (showValidation && validationError);
    const showInvalid = Boolean(displayError);

    return (
      <div className="clinician-onboard-phone-field">
        <WCPhoneInput
          phone={phone}
          invalid={showInvalid}
          onPhoneChange={this.onPhoneChange}
        />
        {displayError && (
          <p className="clinician-onboard-field-error" role="alert">
            {displayError}
          </p>
        )}
      </div>
    );
  };

  render() {
    return (
      <div className="clinician-onboard-phone-step">
        <h2 className="clinician-onboard-title">Phone</h2>

        {RegistrationWizardState.getEmail() && (
          <div className="clinician-onboard-field">
            <label>Email</label>
            <div className="clinician-onboard-readonly-value">
              {RegistrationWizardState.getEmail()}
            </div>
          </div>
        )}

        <div className="clinician-onboard-field">
          <label>Phone number</label>
          <p className="clinician-onboard-field-hint">Required — saved when you tap Next</p>
          {this.renderPhoneField()}
        </div>
      </div>
    );
  }
}

export default PhotoPhoneStep;
